import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Check, Mail, Users, Phone } from "lucide-react";
import useBooking from "../hooks/stores/useBooking";
import { convertUTCToLocalTime } from "../utils/timeUtils";

export default function BookingSuccess() {
  const { bookingData} = useBooking();
  console.log("this is booking page   ",bookingData);
  const navigate = useNavigate();
  useEffect(() => {
    console.log('User auto-logged in after successful booking');
  }, []);

  const handleInviteFriends = () => {
    navigate('/invite-friends');
  };

  // Helper function to format the booking date and time
  const formatBookingDateTime = () => {
    let dateStr = '';
    let timeStr = '';
    let slotDate = '';
    let slotTime = '';

    // Extract date and time from booking data
    if (bookingData?.slotInfo) {
      slotDate = bookingData.slotInfo.slot_date;
      slotTime = bookingData.slotInfo.slot_time;
    } else if (bookingData?.slot_date) {
      slotDate = bookingData.slot_date;
      slotTime = bookingData.slot_time;
    }

    if (slotDate && slotTime) {
      // Format date
      dateStr = new Date(slotDate).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      });

      // Convert UTC time to local time
      timeStr = convertUTCToLocalTime(slotTime, slotDate);

      return `${dateStr} at ${timeStr}`;
    }

    return 'Not available';
  };

  return (
    <div className="min-h-screen bg-background flex items-center">
      <div className="max-w-2xl mx-auto px-4 py-12 text-center">
        <div className="bg-secondary rounded-xl border border-secondary-border p-12">
          {/* Success Icon */}
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Check className="text-green-600 text-3xl" />
          </div>

          <h1 className="text-3xl font-bold text-foreground mb-4">Booking Confirmed!</h1>
          <p className="text-lg text-muted-foreground mb-6">
            Your legacy recording session has been successfully booked. We&apos;re excited to help you capture your story!
          </p>

          {/* Next Steps */}
          <div className="text-left mb-8">
            <h3 className="font-semibold text-foreground mb-4">What Happens Next?</h3>
            <div className="space-y-3 text-sm text-muted-foreground">
              <div className="flex items-start">
                <div className="flex-shrink-0 w-4 h-4 mt-0.5 mr-3 flex items-center justify-center">
                  <Mail className="text-primary" size={16} />
                </div>
                <span>You&apos;ll receive a confirmation email with all of your booking details</span>
              </div>
              <div className="flex items-start">
                <div className="flex-shrink-0 w-4 h-4 mt-1 mr-3 flex items-center justify-center">
                  <Users className="text-primary" size={16} />
                </div>
                <span>Encourage friends and family to put forward some questions (you can invite them using the button below)</span>
              </div>
            </div>
          </div>

          <button onClick={handleInviteFriends} className="btn-primary w-full mb-8">
          Ask your friends & family
          </button>

          {/* Booking Details */}
          <div className="bg-secondary border border-secondary-border rounded-lg p-6 mb-8 text-left">
            <h3 className="font-semibold text-foreground mb-4">Your Booking Details</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-muted-foreground">Date & Time:</span>
                <span className="font-medium text-foreground">
                  {formatBookingDateTime()}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Duration:</span>
                <span className="font-medium text-foreground">
                  {bookingData?.slotInfo?.duration ? `${Math.floor(bookingData.slotInfo.duration / 60)} hours` : '3 hours'}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Booking ID:</span>
                <span className="font-medium text-foreground">
                  #{bookingData?.bookingId || bookingData?.slotInfo?.slot_id || 'PS24031201'}
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-muted-foreground">Amount Paid:</span>
                <span className="font-medium text-foreground">£0.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 